import {
  messageId,
  PropertyMeta,
  ValueObjectMetaNumber,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.number().min(0);
const savedMinimalSchema = z.number().min(0);
const schema = z.number().min(0);
const savedSchema = z.number().min(0);
const jsonSchema = z.number();
/**
 * 細胞ID(値オブジェクト)のメタデータ。
 *
 *  */
export const cellStockIdMeta = new ValueObjectMetaNumber(
  "CellStockId",
  "\u7D30\u80DEID",
  messageId("lbl.\u7D30\u80DEID"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
